import { createRouter, createWebHistory } from 'vue-router'
import { getUserTicketApi, getTicketApi } from '@/utils/user.js'
const wx = require('weixin-js-sdk')
import store from '../store/index.js'
import { Dialog } from 'vant'
import {
  handleUrlStorage,
  getSystem,
  getQueryString,
  getUrlParams,
  isIos,
} from '@/libs/gcontrol'
import routes from './routers'
import { handleConfigtoPath } from '@/libs/jump'
import { getAppIdStorage, setAppIdStorage, getStorage } from '@/libs/storage.js'

const router = createRouter({
  history: createWebHistory(), // hash模式：createWebHashHistory，history模式：createWebHistory
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        left: 0,
        top: 0,
      }
    }
  },
})

/* 全局路由拦截
to 表示从哪里来
from 表示去哪里
next表示是否放行
ticket 公共ticket
ticketPel 个人ticket */
router.beforeEach((to, from, next) => {
  console.log('to=====>', to)

  // 商家助手相关页面，直接放行，不做任何验证
  if (
    to.path === '/merchant-assistant' ||
    to.path === '/merchant-redemption' ||
    to.path === '/redemption-record' ||
    to.path === '/staff-management' ||
    to.path === '/role-management'
  ) {
    console.log('>>> 商家助手页面，直接放行，跳过所有验证')
    next()
    return  // 直接返回，不执行后面的逻辑
  }

  //判断该业务是否推广
  if (to.name !== 'index' || to.name !== 'home') {
    let serviceStatus = handleConfigtoPath(to, 'router')
    console.log('serviceStatus=====>', serviceStatus)
    if (serviceStatus !== 1) {
      window.location.href = `/maintain?serviceStatus=${serviceStatus}`
      return
    }
  }

  //路由守卫内触发更新签名URL
  store.commit('setWechatSignUrl', window.location.href)
  getSystem()
  let appId = localStorage.getItem('appId') || 'wx9a373b1354d442cf'
  let infos_storage = getAppIdStorage(appId)

  //保存将要跳转的路由，以防用户ticket不存在或者过期时，跳转不到指定页面
  if (to.name !== 'index') {
    sessionStorage.setItem('routerPath', to.fullPath)
  }
  const agent = navigator.userAgent
  const isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  if (!to.meta.requireAuth) {
    // 解决ios分享路径和页面签名路径不一致问题
    if (isiOS) {
      store.commit('iosPath', location.pathname)
      let iosPath1 = {
        pathname: location.pathname,
        topath: to.path,
      }
      localStorage.setItem('iospath1', JSON.stringify(iosPath1))
      let infos_storage = getAppIdStorage(appId)
      const url = localStorage.getItem('url')
      infos_storage.iosPath = `${url ? url : ''}${location.pathname}${
        location.search
      }`
      setAppIdStorage(appId, infos_storage)
    }
  }

  //处理每个页面url携带k ---处理缓存问题
  if (to.fullPath !== '/' && to.path !== '/index') {
    to.fullPath = handleUrlStorage(
      to.fullPath,
      JSON.parse(JSON.stringify(from.fullPath))
    )
  }

  //百度统计（每个路由跳转时都将其跳转的路由推给百度）
  // if (window._hmt) {
  //   if (to.path && to.path !== "/index") {
  //     window._hmt.push(["_trackPageview", to.fullPath])
  //   }
  // }
  if (to.path !== '/index') {
    const { aplus_queue } = window
    aplus_queue.push({
      action: 'aplus.sendPV',
      arguments: [{ is_auto: false }], // 此处上报的数据暂时在后台没有展示
    })
  }

  store.commit('fromPath', from.path)

  let ticket = infos_storage.Ticket
  console.log('🚀 ~ router.beforeEach ~ ticket:', ticket)
  let ticketPel = infos_storage.userInfo?.ticket
  console.log('🚀 ~ router.beforeEach ~ ticketPel:', ticketPel)

  //动态设置页面标题
  if (to.meta.title) {
    //有些页面设置渠道商简称
    if (to.meta.showName) {
      document.title = infos_storage?.userConfigInfo?.showName
        ? infos_storage?.userConfigInfo?.showName + '-' + to.meta.title
        : to.meta.title
    } else {
      document.title = to.meta.title
    }
  } else {
    if (appId === 'wxfcb34416b1538017') {
      document.title = ''
    } else {
      document.title = '邦客惠会员商城'
    }
  }

  let environment = getStorage('environment')
  console.log('environment====>', environment)
  //解决有时候app.vue中还没获取到environment
  if (!environment) {
    let timer = setInterval(() => {
      environment = getStorage('environment')
      if (environment) {
        clearInterval(timer)
        handle(
          to,
          from,
          next,
          environment,
          ticket,
          ticketPel,
          appId,
          infos_storage
        )
      }
    }, 1000)
  }
  handle(to, from, next, environment, ticket, ticketPel, appId, infos_storage)
})

function handle(
  to,
  from,
  next,
  environment,
  ticket,
  ticketPel,
  appId,
  infos_storage
) {
  let userInfo = store.state.userInfo
  if (environment == 'wxBrowser' || infos_storage.c === 'h5') {
    //如果路径是index页面，则不走路由拦截的内容，直接走index页面的逻辑
    if (to.name !== 'index') {
      if (
        to.path === '/cardlan' ||
        to.path === '/subscribe' ||
        to.path === '/merchant-assistant' ||
        to.path === '/merchant-redemption' ||
        to.path === '/redemption-record' ||
        to.path === '/staff-management' ||
        to.path === '/role-management'
      ) {
        //这些页面不需要登录
        next()
      } else {
        if (!ticket) {
          //没有公共ticket,先获取公共ticket,再获取个人ticket
          getTicketApi({}).then((res) => {
            let infos_storage_in = getAppIdStorage(appId)
            let ticket = res.data.data.ticket
            infos_storage_in.Ticket = ticket
            let mercode =
              getQueryString('mc', window.localStorage.href) ||
              infos_storage_in.mercode
            setAppIdStorage(appId, infos_storage_in)
            let url = infos_storage_in.url + '/index'
            let params = {
              url,
              mercode, //防止覆盖通过链接进入携带的mercode
            }
            if (to.name == 'distribution') {
              //没有头像 分销中心生成海报需要头像 因此多加参数inUserInfo获取微信头像和昵称
              params.isUserInfo = true
            }
            getUserTicketApi(params).then((res) => {
              window.location.href = res.data.data.redirect_url
            })
          })
        } else {
          //有公共的ticket,则考虑
          // 1、没有个人ticket，则获取个人ticket
          // 2、个人ticket和公共ticket不一致，则获取个人ticket
          if (!ticketPel || ticket !== ticketPel) {
            let infos_storage = getAppIdStorage(appId)
            let url = infos_storage.url + '/index'

            //没有头像 分销中心生成海报需要头像 因此多加参数inUserInfo获取微信头像和昵称
            to.from = from.path
            infos_storage.To = to
            setAppIdStorage(appId, infos_storage)
            let mercode =
              getQueryString('mc', window.localStorage.href) ||
              infos_storage.mercode
            let params = {
              url,
              mercode, //防止覆盖通过链接进入携带的mercode
            }
            if (to.name == 'distribution') {
              //没有头像 分销中心生成海报需要头像 因此多加参数inUserInfo获取微信头像和昵称
              params.isUserInfo = true
            }
            getUserTicketApi(params).then((res) => {
              window.location.href = res.data.data.redirect_url
            })
          } else {
            console.log(to, '直接放行', from)
            next()
          }
        }
      }
    } else {
      next()
    }
  } else if (environment == 'weixin' && infos_storage.c !== 'h5') {
    // 商家助手相关页面直接放行
    if (
      to.path === '/merchant-assistant' ||
      to.path === '/merchant-redemption' ||
      to.path === '/redemption-record' ||
      to.path === '/staff-management' ||
      to.path === '/role-management'
    ) {
      next()
      return
    }

    if (
      to.name == 'distribution' &&
      (!userInfo.avatarUrl ||
        !userInfo.nickName ||
        userInfo.nickName == 'undefined')
    ) {
      let url = ''
      appId = getAppIdStorage(appId).userInfo.appId
      if (appId === 'wx51103d007a84d074') {
        url = `/advertPages/web-view/interactive?type=getUserInfo&ticket=${
          getAppIdStorage(appId).Ticket
        }`
      } else {
        //其他小程序
        url = `/pages/webview/interactive?type=getUserInfo&ticket=${
          getAppIdStorage(appId).Ticket
        }`
      }
      wx.miniProgram.navigateTo({
        url,
      })
    } else {
      next()
    }
  } else if (environment == 'outBrowser') {
    //非微信浏览器需要用户手机号码登录
    console.log('非微信浏览器---------')
    if (
      to.path === '/h5-integral' ||
      to.path === '/index' ||
      to.path === '/h5-record' ||
      to.path === '/h5-faq'
    ) {
      next()
    } else {
      Dialog.alert({
        message: '请在微信客户端浏览器打开',
      }).then(() => {})
    }
    next()
  }
}

export default router
